import React from 'react';
import * as Immutable from "immutable";
import ImmutablePropTypes from 'react-immutable-proptypes';
import {connect} from 'react-redux';
import Paper from 'material-ui/Paper';
import {List, ListItem} from 'material-ui/List';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import {
    loadWorkSessions,
    loadCurrentSession,
    createAndLoadNewSession
} from '../../model/action-creators/work-session-actions';
import { loadWorkSessionItems } from '../../model/action-creators/item-actions'
import {Keys} from '../../model/constants';
import Require from '../components/Require'

class WorksSessionsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sessionTemplateId:!props.workSessionTemplates.isEmpty() ?
                              props.workSessionTemplates.valueSeq().first().get(Keys.ID) : null
        }
        this.handleTemplateChange = this.handleTemplateChange.bind(this);
        this.handleWorkSessionSelection = this.handleWorkSessionSelection.bind(this);
        this.createNewSession = this.createNewSession.bind(this);
    }
    componentWillReceiveProps(props) {
        if (this.state.sessionTemplateId == null) {
            this.setState({
                sessionTemplateId:!props.workSessionTemplates.isEmpty() ?
                                  props.workSessionTemplates.valueSeq().first().get(Keys.ID) : null
            })
        }
    }
    getWorkSessionItems() {
        if (!this.props.workSessions) {
            return
        }
        return this.props.workSessions.map(w => {
            return <ListItem key={w.get(Keys.ID)} primaryText={w.get('name')}
                             onClick={() => this.handleWorkSessionSelection(w.get(Keys.ID))}/>

        })
    }

    handleWorkSessionSelection(workSessionId) {
        this.props.doLoadWorkSession(workSessionId).then( () => {

            console.log('Yay! Work Session Selected!');
            this.context.router.replace('/overview');
        }).then(() => {
            return this.props.doLoadWorkSessionItems(workSessionId);
        });

    }

    getTemplateItems() {
        if (this.props.workSessionTemplates.isEmpty()) {
            return
        }
        return this.props.workSessionTemplates.valueSeq().map(t => {
            const id = t.get(Keys.ID);
            return <MenuItem key={id} value={id} primaryText={t.get('name')}/>
        }).toArray();
    }

    handleTemplateChange(obj, key, templateId) {
        this.setState({sessionTemplateId: templateId});
    }

    createNewSession() {
        this.props.doCreateAndLoadWorkSession(this.state.sessionTemplateId).then( () => {

            console.log('Yay! Work Session Created!');
            this.props.doRefreshWorkSessions();
            this.context.router.replace('/assignees');
        });
    }

    render() {
        const createDiv = this.state.sessionTemplateId == null? null: (
          <div style={{display: 'flex', alignItems:'center'}}>
              <RaisedButton label="Create"
                            onClick={this.createNewSession}/> a
              <DropDownMenu
                  value={this.state.sessionTemplateId}
                  onChange={this.handleTemplateChange}
              >
                  {this.getTemplateItems()}
              </DropDownMenu>

          </div>);

        return (
            <Paper>
                <Require initialized={true}>
                    <div>
                        <div>
                            <List>
                                {this.getWorkSessionItems()}
                            </List>
                        </div>
                        {createDiv}
                    </div>
                    <div>
                        <RefreshIndicator
                        size={40}
                        left={10}
                        top={0}
                        status="loading"
                        style={{
                            display: 'inline-block',
                            position: 'relative',
                        }}
                    /></div>
                </Require>
            </Paper>
        )
    }
}

WorksSessionsPage.propTypes = {
    workSessions:ImmutablePropTypes.map.isRequired,
    workSessionTemplates:ImmutablePropTypes.map.isRequired,
    currentWorkSession:ImmutablePropTypes.map.isRequired,
    doRefreshWorkSessions:React.PropTypes.func.isRequired,
    doLoadWorkSession:React.PropTypes.func.isRequired,
    doCreateAndLoadWorkSession:React.PropTypes.func.isRequired,
    doLoadWorkSessionItems:React.PropTypes.func.isRequired,
};

const mapSateToProps = (state) => {
    return {
        workSessions: state.workSessionsState.get(Keys.StoreSliceData.WORK_SESSIONS,Immutable.Map()),
        workSessionTemplates: state.workSessionTemplatesState.get(Keys.StoreSliceData.WORK_SESSION_TEMPLATES,Immutable.Map()),
        currentWorkSession: state.currentWorkSessionState.get(Keys.StoreSliceData.CURRENT_WORK_SESSION, Immutable.Map()),
    }
};
const mapDispatchToProps = (dispatch) => {
    return {
        doRefreshWorkSessions: () => dispatch(loadWorkSessions()),
        doLoadWorkSession: (workSessionId) => dispatch(loadCurrentSession(workSessionId)),
        doCreateAndLoadWorkSession: (templateId) => dispatch(createAndLoadNewSession(templateId)),
        doLoadWorkSessionItems: (workSessionId) => dispatch(loadWorkSessionItems(workSessionId)),
    }
};
WorksSessionsPage.contextTypes = {
    router:React.PropTypes.object
};

export default connect(mapSateToProps, mapDispatchToProps)(WorksSessionsPage);



// WEBPACK FOOTER //
// ./src/ui/pages/WorkSessionsPage.js